<template lang="pug">
  .component-tabbed-vehicle-costs
    CreateNoteModal(:entity="note.type", :entityId="$route.params.id", @noteCreated="$refs.notesBaseList.loadData(1)")

    .container
      base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false", ref="notesBaseList", component-type="entityList")


</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice"
  import moment from 'moment'
  import BaseList from '../../../pages/backoffice/BaseList'
  import HeaderColumns from '../../structure/ui/HeaderColumns'
  import collect from 'collect.js'
  import ModalReveal from '../../structure/foundation/ModalReveal'
  import MaggieHelper from "../../../maggieHelper";
  import CreateNote from "../../../pages/backoffice/CreateNote";
  import CreateNoteModal from "../../../pages/backoffice/CreateNoteModal";

  export default {
    name: "ReservationNotes",
    components: {
      CreateNoteModal,
      CreateNote,
      ModalReveal,
      HeaderColumns,
      BaseList,
    },
    data() {
      return {
        note: {type: 'App\\Models\\Reservation', id: null, description: null},
        component: require('src/components/backoffice/Note'),
      }
    },
    methods: {
      dataLoader(callback, page = 1, resultsPerPage = 25) {
        KeplerBackofficeSdk.notes.list().all({
          per_page: resultsPerPage,
          page_number: page,
          type: 'App\\Models\\Reservation',
          id:this.$route.params.id
        }, (data) => {
          callback(data)
        })
      },
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-vehicle-costs
    width: 100%
    padding-bottom: 25px
    .container
      margin: 20px
    .roi
      .inner-content
        padding-top: 0
</style>



// WEBPACK FOOTER //
// ReservationNotes.vue?74eee481